export const CHANGE_STATE = 'CHANGE_STATE'
export const SETUP_QCAA = 'SETUP_QCAA'
export const SETUP_EXAMS = 'SETUP_EXAMS'
export const BLANK_EXAM = 'BLANK_EXAM'
export const CHANGE_STUDENT_SEATING = 'CHANGE_SEATING'
export const BOOK_ALL = 'BOOK_ALL'
export const BOOK_ALL_RECOMMENDED = "BOOK_ALL_RECOMMENDED";
export const SET_RECOMMENDED_SEATING = 'SET_RECOMMENDED_SEATING'
export const CHANGE_BOOKING_NOTES = 'CHANGE_BOOKING_NOTES'
export const GET_RETURNED_EXAM = 'GET_RETURNED_EXAM'